import { Box, Divider, Grid2, keyframes, Typography } from '@mui/material';
import ButtonComponent from '../../../components/ButtonComponent';
import { SipClientStatus } from '../../../services/SipClientService/enums';
import { Camera, Close, Phone } from '@mui/icons-material';
import WebRTCPlayer from './WebRtcPlayer';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '../../../context/AppContextProvider';
import {
  useHangupSipClientAsync,
  useRefuseSipClientAsync,
  useToMeetSipClientAsync,
} from '../../../services/SipClientService/hooks/useMutation';
import DeviceDirectConnectionStreamComponent from '../../../components/DeviceDirectConnectionStreamComponent';
import CardComponent from '../../../components/CardComponent/CardComponent';

const ringAnimation = keyframes`
  0% { transform: rotate(0deg); }
  10% { transform: rotate(-15deg); }
  20% { transform: rotate(15deg); }
  30% { transform: rotate(-15deg); }
  40% { transform: rotate(15deg); }
  50% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
`;

const CallRender = () => {
  const { sipClientStatusDetails, sipClientRegister, renderTitle } =
    useContext(AppContext);
  const [isRenderVideo, setIsRenderVideo] = useState(true);

  const {
    mutateAsync: mutateRefuseSipClientAsync,
    isLoading: isLoadingRefuseSipClientAsync,
  } = useRefuseSipClientAsync();

  const {
    mutateAsync: mutateToMeetSipClientAsync,
    isLoading: isLoadingToMeetSipClientAsync,
  } = useToMeetSipClientAsync();

  const {
    mutateAsync: mutateHangupSipClientAsync,
    isLoading: isLoadingHangupSipClientAsync,
  } = useHangupSipClientAsync();

  const onRefuseCall = async (callId: string) => {
    if (sipClientRegister)
      await mutateRefuseSipClientAsync({
        callId,
        id: sipClientRegister.id,
      });
  };

  const onToMeetAsync = async (callId: string) => {
    if (sipClientRegister)
      await mutateToMeetSipClientAsync({
        callId,
        id: sipClientRegister.id,
      });
  };

  const onHangupCall = async (callId: string) => {
    if (sipClientRegister)
      await mutateHangupSipClientAsync({
        callId,
        id: sipClientRegister.id,
      });
  };

  const handleChangeVideoVisibility = async () => {
    if (sipClientRegister) setIsRenderVideo(!isRenderVideo);
  };

  return (
    <Box width={'100%'} color={'white'}>
      <Box display={'flex'} justifyContent={'center'} marginBottom={3}>
        <Typography variant={'h4'}>{renderTitle()}</Typography>
      </Box>
      {sipClientStatusDetails.status !== SipClientStatus.NO_ACTIVITY &&
      sipClientStatusDetails.status !== SipClientStatus.CALLING &&
      sipClientStatusDetails.status !==
        SipClientStatus.CALL_WAITING_WHILE_CALLING &&
      sipClientStatusDetails.callInfos[0].deviceId ? (
        <Box marginY={2}>
          <DeviceDirectConnectionStreamComponent
            isEnableVideo={isRenderVideo}
            deviceName={sipClientStatusDetails.callInfos[0].deviceName}
            deviceId={sipClientStatusDetails.callInfos[0].deviceId}
          />
        </Box>
      ) : (
        <></>
      )}
      <Grid2
        container
        position={'relative'}
        display="flex"
        justifyContent="space-between"
        width={'100%'}
        columnSpacing={2}
      >
        <Grid2 size={12} justifyContent={'space-evenly'} container>
          <Grid2>
            <ButtonComponent
              color="success"
              // loading={isLoadingRefuseSipClientAsync}
              disabled={
                sipClientStatusDetails.status !==
                  SipClientStatus.RECEIVING_CALL &&
                sipClientStatusDetails.status !==
                  SipClientStatus.MANY_CALL_WAITING
              }
              loading={isLoadingToMeetSipClientAsync}
              tooltipMessage={'Atender'}
              sx={{
                borderRadius: '50%',
                p: 3,
                animation:
                  sipClientStatusDetails.status ===
                    SipClientStatus.RECEIVING_CALL ||
                  sipClientStatusDetails.status ===
                    SipClientStatus.MANY_CALL_WAITING
                    ? `${ringAnimation} 0.8s infinite`
                    : 'none',
              }}
              onClick={() =>
                onToMeetAsync(sipClientStatusDetails.callInfos[0].callId)
              }
              iconOnly
            >
              <Phone />
            </ButtonComponent>
          </Grid2>
          <Grid2>
            <ButtonComponent
              color="secondary"
              // loading={isLoadingRefuseSipClientAsync}
              disabled={!sipClientStatusDetails.callInfos[0].deviceId}
              tooltipMessage={!isRenderVideo ? 'Abrir vídeo' : 'Fechar vídeo'}
              onClick={() => handleChangeVideoVisibility()}
              sx={{ borderRadius: '50%', p: 3 }}
              iconOnly
            >
              <Camera />
            </ButtonComponent>
          </Grid2>
          <Grid2>
            <ButtonComponent
              sx={{ borderRadius: '50%', p: 3 }}
              color="error"
              loading={
                isLoadingHangupSipClientAsync || isLoadingRefuseSipClientAsync
              }
              tooltipMessage={
                sipClientStatusDetails.status ===
                  SipClientStatus.RECEIVING_CALL ||
                sipClientStatusDetails.status ===
                  SipClientStatus.MANY_CALL_WAITING
                  ? 'Recusar'
                  : 'Desligar'
              }
              // loading={isLoadingRefuseSipClientAsync}
              onClick={() =>
                sipClientStatusDetails.status ===
                  SipClientStatus.RECEIVING_CALL ||
                sipClientStatusDetails.status ===
                  SipClientStatus.MANY_CALL_WAITING
                  ? onRefuseCall(sipClientStatusDetails.callInfos[0].callId)
                  : onHangupCall(sipClientStatusDetails.callInfos[0].callId)
              }
            >
              <Close />
            </ButtonComponent>
          </Grid2>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }} columnSpacing={1}>
          {(sipClientStatusDetails.status === SipClientStatus.CALL_WAITING ||
            sipClientStatusDetails.status ===
              SipClientStatus.MANY_CALL_WAITING ||
            sipClientStatusDetails.status ===
              SipClientStatus.CALL_WAITING_WHILE_CALLING) && (
            <>
              <Grid2 size={12} sx={{ mb: 2 }}>
                <Divider sx={{ my: 2, backgroundColor: 'rgb(47, 57, 87)' }} />

                <Typography fontWeight={'bold'} fontSize={20}>
                  Chamadas em espera
                </Typography>
              </Grid2>
              <Grid2 sx={{ width: '100%' }} size={{ xs: 12, md: 6 }}>
                {sipClientStatusDetails.callInfos.map(
                  (item, index) =>
                    index != 0 && (
                      <CardComponent
                        key={item.callId}
                        title={item.callFromName}
                      >
                        <Box display={'flex'} justifyContent={'space-between'}>
                          <ButtonComponent
                            color={'success'}
                            size={'small'}
                            loading={isLoadingToMeetSipClientAsync}
                            tooltipMessage={'Atender'}
                            onClick={() => onToMeetAsync(item.callId)}
                          >
                            <Phone
                              fontSize={'small'}
                              sx={{
                                animation: `${ringAnimation} 0.8s infinite`,
                              }}
                            />
                          </ButtonComponent>
                          <ButtonComponent
                            loading={isLoadingRefuseSipClientAsync}
                            color={'error'}
                            size={'small'}
                            tooltipMessage={'Recusar'}
                            onClick={() => onRefuseCall(item.callId)}
                          >
                            <Close fontSize={'small'} />
                          </ButtonComponent>
                        </Box>
                      </CardComponent>
                    ),
                )}
              </Grid2>
            </>
          )}
        </Grid2>
      </Grid2>
      <WebRTCPlayer status={sipClientStatusDetails} />
    </Box>
  );
};

export default CallRender;
